import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import Account from "./Components/Account/Account";

export const isAuthenticated = () => {
  const user_id = localStorage.getItem("userId");
  return !!user_id;
};

const AccountRoute = () => {
  const [authenticated, setAuthenticated] = useState(isAuthenticated());
  useEffect(() => {
    const checkAuth = () => {
      setAuthenticated(isAuthenticated());
    };
    window.addEventListener("storage", checkAuth);
    return () => {
      window.removeEventListener("storage", checkAuth);
    };
  }, []);
  return authenticated ? <Account /> : <Navigate to="/login" />;
};
export default AccountRoute;
